module.exports = __webpack_public_path__ + "img/sports.a6fa867e.svg";